/* ── Quick Add Button Custom Element ── */
class QuickAddButton extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    if (this.button) {
      this.button.addEventListener('click', this.onAdd.bind(this));
    }
  }

  onAdd() {
    var variantId = this.dataset.variantId;
    if (!variantId || !this.button) return;

    var btn = this.button;
    btn.classList.add('is-loading');
    btn.disabled = true;

    window.ShopUtils.addToCart(parseInt(variantId, 10), 1)
      .then(function () {
        window.pubsub.publish('cart:open');
      })
      .catch(function (err) {
        console.warn('[QuickAdd]', err);
        window.StratOSToast && window.StratOSToast.show(
          (err && err.message) || 'Impossible d\'ajouter ce produit.',
          'error'
        );
      })
      .finally(function () {
        btn.classList.remove('is-loading');
        btn.disabled = false;
      });
  }
}

customElements.define('quick-add-button', QuickAddButton);
